import React from 'react';

import { useAnalyticsQueryParams } from '@candu-ai/analytics/search';
import { QueryId } from '@candu-ai/analytics/types';
import { LineGraph } from 'craft/containers/Toolbox/tabs/InteractionAnalytics/LineGraph';

interface Props {
  documentNodeId: string;
  contentId: string;
}

export const Generic = ({ contentId, documentNodeId }: Props) => {
  const queryParams = useAnalyticsQueryParams({
    documentNodeId,
    contentId,
  });

  return (
    <>
      <LineGraph
        title="Interactions"
        legend="interactions"
        withTotalPrefix
        queryId={QueryId.InteractionsTimeseries}
        queryParams={queryParams}
      />

      <LineGraph
        title="Conversion rate"
        legend="conversion rate"
        unit="%"
        queryId={QueryId.ConversionRateTimeseries}
        aggregateQueryId={QueryId.ConversionRateMetric}
        queryParams={queryParams}
      />
    </>
  );
};
